import PocketBase from 'pocketbase';

// Función para obtener la URL de PocketBase dinámicamente
const getPocketBaseUrl = (): string => {
  // Verificar si existe la configuración global (generada dinámicamente en Docker)
  if (typeof window !== 'undefined' && (window as any).APP_CONFIG) {
    const config = (window as any).APP_CONFIG
    return config.API_BASE_URL || config.VITE_POCKETBASE_URL || 'http://localhost:8089'
  }
  
  // Fallback a variables de entorno de Vite (desarrollo)
  return import.meta.env.VITE_POCKETBASE_URL || 'http://localhost:8089'
}

// Configuración de PocketBase usando configuración dinámica
const POCKETBASE_URL = getPocketBaseUrl();
const pb = new PocketBase(POCKETBASE_URL);

// Log de configuración en desarrollo
if (import.meta.env.DEV) {
  console.log('PocketBase URL:', POCKETBASE_URL);
}

// Tipos para autenticación
export interface User {
  id: string;
  storeId: string;
  email: string;
  name: string;
  role?: string;
  created: string;
  updated: string;
}

export interface AuthState {
  user: User | null;
  isAuthenticated: boolean;
  isLoading: boolean;
}

// Función para obtener el usuario actual
export const getCurrentUser = (): User | null => {
  if (pb.authStore.isValid) {
    return pb.authStore.model as User;
  }
  return null;
};

// Función para hacer login
export const login = async (email: string, password: string): Promise<User> => {
  try {
    const authData = await pb.collection('users').authWithPassword(email, password);
    return authData.record as unknown as User;
  } catch (error) {
    console.error('Error en login:', error);
    throw error;
  }
};

// Función para registrar usuario
export const register = async (email: string, password: string, name: string): Promise<User> => {
  try {
    const data = {
      email,
      password,
      passwordConfirm: password,
      name,
    };
    
    const record = await pb.collection('users').create(data);
    
    // Hacer login automático después del registro
    await pb.collection('users').authWithPassword(email, password);
    
    return record as unknown as User;
  } catch (error) {
    console.error('Error en registro:', error);
    throw error;
  }
};

// Función para hacer logout
export const logout = (): void => {
  pb.authStore.clear();
};

// Función para verificar si el usuario está autenticado
export const isAuthenticated = (): boolean => {
  return pb.authStore.isValid;
};

// Listener para cambios en el estado de autenticación
export const onAuthChange = (callback: (user: User | null) => void): (() => void) => {
  const unsubscribe = pb.authStore.onChange(() => {
    callback(getCurrentUser());
  });
  
  return unsubscribe;
};

export default pb;
